import axios from 'axios';
import { API_BASE_URL } from '../config/constants';

const SHEET_SOURCE_API = `${API_BASE_URL}/api/sheet-sources`;

export const sheetSourceService = {
  // Add new sheet source
  addSheet: async ({ sheetId, gid, name }) => {
    const response = await axios.post(SHEET_SOURCE_API, { sheetId, gid, name });
    return response.data;
  },

  // List all sheet sources
  listSheets: async () => {
    const response = await axios.get(SHEET_SOURCE_API);
    return response.data;
  },

  // Delete sheet source
  deleteSheet: async (sheetId, gid) => {
    const response = await axios.delete(`${SHEET_SOURCE_API}/${sheetId}/${gid}`);
    return response.data;
  },

  // Update header mapping
  updateMapping: async (sheetId, gid, mapping) => {
    const response = await axios.put(`${SHEET_SOURCE_API}/${sheetId}/${gid}/mapping`, {
      headerMapping: mapping
    });
    return response.data;
  },

  // Fetch latest data from sheet
  fetchSheet: async (sheetId, gid = '0') => {
    const response = await axios.post(`${SHEET_SOURCE_API}/${sheetId}/${gid}/fetch`);
    return response.data;
  },

  // Import leads from sheet
  importLeads: async (sheetId, gid = '0', options = {}) => {
    const queryParams = new URLSearchParams(options).toString();
    const response = await axios.post(`${SHEET_SOURCE_API}/${sheetId}/${gid}/import${queryParams ? `?${queryParams}` : ''}`);
    return response.data;
  },

  // Import leads from all sheets
  importAllLeads: async (options = {}) => {
    const queryParams = new URLSearchParams(options).toString();
    const response = await axios.post(`${SHEET_SOURCE_API}/import-all${queryParams ? `?${queryParams}` : ''}`);
    return response.data;
  }
};
